import script from "./Radio.vue?vue&type=script&setup=true&lang=ts"
export * from "./Radio.vue?vue&type=script&setup=true&lang=ts"

import "./Radio.vue?vue&type=style&index=0&id=379fc7ac&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-379fc7ac"]])

export default __exports__